import React from 'react';
import { Container } from './ui/Container';
import { PauseCircleIcon, WindIcon, ArrowDownCircleIcon, BedDoubleIcon } from 'lucide-react';
export function ProtocolSection() {
  const steps = [{
    icon: PauseCircleIcon,
    title: '1. Detener',
    desc: 'Cortar la película mental en 20 segundos (sin discutir contigo misma).',
    color: 'text-amber-400'
  }, {
    icon: WindIcon,
    title: '2. Desinflar',
    desc: 'Bajar el volumen con una respiración simple (sin intentar hacerlo perfecto).',
    color: 'text-cyan-400'
  }, {
    icon: ArrowDownCircleIcon,
    title: '3. Descender',
    desc: 'Micro-ajustes para que el cuerpo deje de “gritar” (sin prender luces).',
    color: 'text-emerald-400'
  }, {
    icon: BedDoubleIcon,
    title: '4. Dormir',
    desc: 'Un guion anti-pánico + un ancla aburrida (para que el sueño regrese).',
    color: 'text-indigo-400'
  }];
  return <section className="py-20 bg-slate-900 border-y border-slate-800" data-id="element-144">
      <Container data-id="element-145">
        <div className="text-center mb-16" data-id="element-146">
          <span className="text-indigo-400 font-medium tracking-wider uppercase text-sm" data-id="element-147">
            El Mecanismo
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-2" data-id="element-148">
            Protocolo 4D
          </h2>
          <p className="text-slate-400 mt-4 max-w-2xl mx-auto" data-id="element-149">
            Un sistema diseñado para ejecutarse medio dormida, sin necesidad de
            pensar ni tomar decisiones.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-150">
          {steps.map((step, index) => <div key={index} className="bg-slate-950 p-6 rounded-xl border border-slate-800 hover:border-slate-700 transition-colors relative group" data-id="element-151">
              <div className="absolute -top-4 left-6 bg-slate-900 border border-slate-800 p-2 rounded-lg shadow-lg group-hover:scale-110 transition-transform" data-id="element-152">
                <step.icon className={`w-6 h-6 ${step.color}`} data-id="element-153" />
              </div>
              <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-154">
                {step.title}
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed" data-id="element-155">
                {step.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-12 text-center bg-indigo-950/30 p-6 rounded-lg border border-indigo-900/30 max-w-3xl mx-auto" data-id="element-156">
          <p className="text-indigo-200 font-medium" data-id="element-157">
            ✨ Incluye una tarjeta imprimible para tu mesita de noche.
            <span className="block text-slate-400 text-sm mt-2 font-normal" data-id="element-158">
              Porque a las 3AM, leer páginas en una pantalla no es realista.
              Necesitas una hoja física.
            </span>
          </p>
        </div>
      </Container>
    </section>;
}